import viewLegalDocButton from "../../assets/Icons/read_more.png";
import { TouchableOpacity, Image } from "react-native";
import { globalAny } from "../../utils/Utils";
import { Container, Label } from "./styled";
import useGenericContentStore from "../../store/genericContent.store";

interface Props {
	onPress?: () => void;
}

const PrivacyPolicyButton = ({ onPress }: Props) => {
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));
	return (
		<TouchableOpacity onPress={onPress}>
			<Container isNarrow={isNarrow}>
				<Image source={{ uri: viewLegalDocButton }} resizeMode="contain" style={{ width: isNarrow ? 32 : 45, height: isNarrow ? 32 : 45 }} />
				<Label isNarrow={isNarrow}>{globalAny.language.privacy_policy}</Label>
			</Container>
		</TouchableOpacity>
	);
};

export default PrivacyPolicyButton;
